import { createAction } from '@reduxjs/toolkit'

import { TAnalysisDetailResponse, TAnalysisResponse } from 'redux/api/Analyses'

// tryGetAllAnalyses
export const getAll = createAction('get_all_analyses')
export const getAllSuccess = createAction<TAnalysisResponse[]>(
  'get_all_analyses_success'
)
export const getAllFailed = createAction('get_all_analyses_failed')

// tryGetOneAnalysis
export const getOne = createAction('get_one_analysis')
// The analysis type comes along, for AnalysisTypeStore to take.
export const getOneSuccess = createAction<TAnalysisDetailResponse>(
  'get_one_analysis_success'
)
export const getOneFailed = createAction('get_one_analysis_failed')

// tryUpdateAnalysis
export const update = createAction('update_analysis')
export const updateSuccess = createAction<TAnalysisResponse>(
  'update_analysis_success'
)
export const updateFailed = createAction('update_analysis_failed')

// tryUpdateAnalysisSelection
export const updateSelection = createAction('update_analysis_selection')
export const updateSelectionSuccess = createAction<TAnalysisResponse>(
  'update_analysis_selection_success'
)
export const updateSelectionFailed = createAction(
  'update_analysis_selection_failed'
)

// tryDeleteAnalysis
export const destroy = createAction('delete_analysis')
export const destroySuccess = createAction<string>('delete_analysis_success')
export const destroyFailed = createAction('delete_analysis_failed')
